import React from "react";

const Acknowledgement = () => {
  return <div>Acknowledgement</div>;
};

export default Acknowledgement;
